var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { ButtonStyle } from './prop-types';
const Button = (_a) => {
    var { link, buttonType = 'button', className = [], title, loading = false, icon, onClick } = _a, rest = __rest(_a, ["link", "buttonType", "className", "title", "loading", "icon", "onClick"]);
    if (loading || icon) {
        className.push(ButtonStyle.Icons);
        if (loading) {
            className.push(ButtonStyle.Loading);
        }
    }
    if (link) {
        return (_jsxs(Link, Object.assign({ to: link, className: `button ${className.join(' ')}` }, rest, { children: [(loading || icon) &&
                    _jsxs("div", Object.assign({ className: "button__icon-container" }, { children: [_jsxs("div", Object.assign({ className: "loader--ring" }, { children: [_jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0)] }), void 0), _jsx("i", { className: `button__icon fas ${icon}` }, void 0)] }), void 0), !loading && title] }), void 0));
    }
    return (_jsxs("button", Object.assign({ className: `button ${className.join(' ')}`, type: buttonType, onClick: onClick }, rest, { children: [(loading || icon) &&
                _jsxs("div", Object.assign({ className: "button__icon-container" }, { children: [loading && (_jsxs("div", Object.assign({ className: "loader--ring" }, { children: [_jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0)] }), void 0)), icon && (_jsx(FontAwesomeIcon, { className: 'button__icon', icon: icon }, void 0))] }), void 0), !loading && title !== '' && _jsx("span", Object.assign({ className: "button__text" }, { children: title }), void 0)] }), void 0));
};
export default Button;
